import * as React from 'react';

import LimitedApp56 from './LimitedApp56';

export const limitedApp56 = () => <LimitedApp56 />;

export default {
    title: 'Illustration/LimitedApp56',
    component: LimitedApp56,
    parameters: {
        notes: "`import LimitedApp56 from 'box-ui-elements/es/illustration/LimitedApp56';`",
    },
};
